import { render, staticRenderFns } from "./Bitmovin.vue?vue&type=template&id=23c25eca&scoped=true&"
import script from "./Bitmovin.vue?vue&type=script&lang=js&"
export * from "./Bitmovin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c25eca",
  null
  
)

export default component.exports